import { useQuery } from '@tanstack/react-query';
import { referralPartnerApi } from '@/api/referralPartner';

const statusColor: Record<string, string> = {
  REQUESTED: 'text-amber-400',
  APPROVED: 'text-blue-400',
  PAID: 'text-emerald-400',
  REJECTED: 'text-red-400',
};

export default function PartnerPayouts() {
  const { data = [], isLoading, isError } = useQuery({
    queryKey: ['partner-payouts'],
    queryFn: async () => {
      const res = await referralPartnerApi.payouts();
      return res.data?.data ?? [];
    },
  });

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-white">Payouts</h2>
        <p className="text-slate-400">Settlement history and status</p>
      </div>
      {isLoading ? (
        <p className="text-slate-400">Loading…</p>
      ) : isError ? (
        <p className="text-slate-400">Failed to load payouts. Please refresh.</p>
      ) : (
        <div className="space-y-3">
          {(data as Array<{
            id: string;
            status: string;
            totalPoints: number;
            amountInr: number;
            paymentReference?: string;
            requestedAt: string;
            paidAt?: string;
            hospital: { name: string };
          }>).map((p) => (
            <div
              key={p.id}
              className="rounded-2xl border border-white/10 bg-white/5 p-5"
            >
              <div className="flex justify-between items-start">
                <div>
                  <p className="font-semibold text-white">{p.hospital.name}</p>
                  <p className="text-xs text-slate-500 mt-1">
                    {new Date(p.requestedAt).toLocaleString('en-IN')}
                  </p>
                </div>
                <span className={`text-sm font-medium ${statusColor[p.status] ?? 'text-slate-400'}`}>
                  {p.status}
                </span>
              </div>
              <div className="mt-3 flex gap-6 text-sm">
                <span className="text-slate-400">
                  Points: <strong className="text-white">{p.totalPoints}</strong>
                </span>
                <span className="text-slate-400">
                  Amount: <strong className="text-cyan-400">₹{p.amountInr.toLocaleString('en-IN')}</strong>
                </span>
              </div>
              {p.paymentReference && (
                <p className="mt-2 text-xs text-slate-500">Ref: {p.paymentReference}</p>
              )}
            </div>
          ))}
          {!data?.length && (
            <p className="text-center text-slate-500 py-12">No payout requests yet</p>
          )}
        </div>
      )}
    </div>
  );
}
